import { render, staticRenderFns } from "./Compensate.vue?vue&type=template&id=259c04a1&"
import script from "./Compensate.vue?vue&type=script&lang=js&"
export * from "./Compensate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports